export default (...args) => args.map((arg) => `${arg}`).join("");
